import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_universoquant.png",
      alt: "Estratégias UniversoQUANT",
    },
    title: "Faça parte do UniversoQUANT",

    // String ou array de strings
    text: [
      "O UniversoQUAT utiliza algorítmos modernos e dados quant alternativos. Criado por quem entende de tecnologia, você terá nesta extensão as possibilidades de investimentos mais criativas e QUANT do mercado",
    ],
    testimonial: {
      text: "Todo mercado tem sua Lógica. Para toda Lógica, o UniversoQUANT tem um algorítimo",
      author: {
        name: "Doug Braga",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/foto-edson-3-150x150.jpg",
      },
    },
  },

  strategies: {
    title: "Estratégias Universo QUANT",
    heading: "Algoritmos modernos a um click de distância",
    // subtitle:
    //   "Todas as 8 estratégias foram desenvolvidas utilizando técnicas avançadas de inteligência artificial que vão se adaptando às mudanças do mercado.",
  },

  cta: {
    title: "Faça parte deste movimento",
    subtitle: "Quero fazer parte do UniversoQUANT",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "O UniversoQUANT",
    col1: [
      "O UniversoQUANT nasceu com o objetivo de encontrar lógica no mercado e trazer liberdade para o trader. Com mais de 10 anos de estudos voltados a inteligência artificial e analise de dados, com mais de 20 anos de experiência em tecnologia e com um robô desenvolvido e testado por 4 anos, agora é a sua vês de fazer parte deste movimento.",
    ],
    // col2: [
    // ],
  },

  stats: {
    title: "Alguns números relevantes sobre o UniversoQUANT",
    subtitle:
      "Todas as estratégias utilizando o mesmo Robô Búffalo, com mais de 4 anos de testes massivos de milhares de linhas de código buscando consistência e segurança na operação",
    data: [
      {
        value: "+2k",
        description: "Horas de desenvolvimento",
      },
      {
        value: "+8k",
        description: "Horas de testes",
      },
      {
        value: "+2k",
        description: "Linhas de código fonte",
      },
    ],
  },

  features: {
    title: "Vantagens",
    subtitle: "Veja quais as principais vantagens dos robôs do UniversoQUANT.",
    data: [
      {
        icon: iconsSet.money,
        title: "Estratégia para você lucrar seus primeiros R$100,00 na bolsa",
        // description:
        //   "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "Modelos matemáticos 100% automatizados",
        // description:
        //   "Que vão trazer vida longa aos seus investimentos em renda variável.",
      },
      {
        icon: iconsSet.chip,
        title: "Tecnologia de ponta, a sua disposição",
        // description:
        //   "Todos os ajustes das estratégias são realizados automaticamente.",
      },
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão UniversoQUANT",
  },

  // testimonials: [
  //   {
  //     text: "Estou divulgando o seu robô para todos os meus amigos traders.",
  //     author: "Humberto Chagas",
  //     job: "Médico",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
  //   },
  //   {
  //     text: "Quero parabenizá-lo pelo trabalho desenvolvido e pela seriedade, sempre prezando pelo resultado e satisfação do cliente.",
  //     author: "Marcelo Machado",
  //     job: "Advogado",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
  //   },
  // ],
};
